import { Outlet } from "react-router-dom";

function CoinPage() {
   return <Outlet />;
}

export default CoinPage;
